import script from "./GruposRepository.vue?vue&type=script&lang=js"
export * from "./GruposRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__